import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
};

const permissionModalSlice = createSlice({
  name: 'permissionModal',
  initialState,
  reducers: {
    showInsufficientPermissionModal: (state) => {
      state.open = true;
    },
    hideInsufficientPermissionModal: (state) => {
      state.open = false;
    },
  },
});

export const { showInsufficientPermissionModal, hideInsufficientPermissionModal } = permissionModalSlice.actions;

export default permissionModalSlice.reducer;
